'use strict';

var servicesScale = require('../factories/ChartPriceRecommendationServicesScale');
var _ = require('lodash');
var ChartPriceRecommendationServicesDirective = function ChartPriceRecommendationServicesDirective(Chart, chartYAxis, chartConstants) {
  return {
    restrict: 'E',
    template: require('../templates/chart-price-recommendation-services.html'),
    scope: {},
    replace: true,
    controller: 'ChartPriceRecommendationServicesController',
    link: function link(scope, element) {
      var BAR_WIDTH = 40;
      var BAR_PADDING = 20;
      var yAxisLeft = chartYAxis(scope.chartFormatters.yAxisTickFormatter, chartConstants.AXIS.MODE.LEFT).withoutHorizontalLines().label('Closed Classes');
      var yAxisRight = chartYAxis(scope.chartFormatters.yAxisTickFormatter, chartConstants.AXIS.MODE.RIGHT).withoutHorizontalShift().withoutHorizontalLines().label('Effective Fare Change');
      var chartPricingServices = new Chart(element.find('.chart-container'), scope.chartFormatters, servicesScale, yAxisLeft, yAxisRight);
      scope.$watch('data', function () {
        if (scope.data === undefined) {
          return;
        }
        scope.minWidth = scope.data.length * (BAR_WIDTH + BAR_PADDING);
        scope.renderChart();
      });
      scope.renderChart = function () {
        if (scope.data === undefined) {
          return;
        }
        scope.isDataPresent = !_.isEmpty(scope.data);
        scope.toggleVisibility(scope.isDataPresent);
        scope.setErrorMessage(scope.data);
        scope.renderChartDataPresent(scope.data);
      };
      scope.renderChartDataPresent = function (data) {
        scope.$evalAsync(function () {
          setTimeout(function () {
            chartPricingServices.render(data);
          }, 0);
          scope.$broadcast('perfect-scrollbar:update');
        });
      };
      scope.$on('chart:DepartureDate:selectedDepartureDate', function (event, selectedDepartureDate) {
        scope.redrawChartWithSelectedDepartureDate(selectedDepartureDate);
      });
      chartPricingServices.on('selectedService', function (selectedData, index) {
        scope.data = scope.selectService(index);
        scope.renderChartDataPresent(scope.data);
        scope.emitSelectedService(selectedData);
      });
    }
  };
};
ChartPriceRecommendationServicesDirective.$inject = ['ChartPriceRecommendationServices', 'ChartElementsYAxis', 'ChartElementsConstants'];
module.exports = ChartPriceRecommendationServicesDirective;